export class UserCancelledOperationError extends Error {}

export function silenceUserCancellationErrors(error: any) {
  if (!(error instanceof UserCancelledOperationError)) throw error;
}
